import React from 'react';

const PRESETS = {
  Y: { label: '사용', color: 'green' },
  N: { label: '미사용', color: 'gray' },
  SUCCESS: { label: '성공', color: 'green' },
  FAIL: { label: '실패', color: 'red' },
  NORMAL: { label: '정상', color: 'green' },
  WITHDRAWN: { label: '탈퇴', color: 'red' },
  DORMANT: { label: '휴면', color: 'yellow' },
  SUPER_ADMIN: { label: '최고관리자', color: 'blue' },
  ADMIN: { label: '일반관리자', color: 'gray' },
  STORE_ADMIN: { label: '매장관리자', color: 'yellow' },
  ON_SALE: { label: '판매중', color: 'green' },
  STOPPED: { label: '판매중단', color: 'red' },
  PAID: { label: '결제완료', color: 'blue' },
  READY: { label: '상품준비중', color: 'yellow' },
  SHIPPING: { label: '배송중', color: 'blue' },
  DELIVERED: { label: '배송완료', color: 'green' },
  CANCELLED: { label: '주문취소', color: 'red' },
  REFUNDED: { label: '환불완료', color: 'gray' },
  EMPTY: { label: '공석', color: 'gray' },
  IN_USE: { label: '사용중', color: 'blue' },
  RECEIVED: { label: '접수', color: 'yellow' },
  COOKING: { label: '조리중', color: 'blue' },
  SERVED: { label: '서빙완료', color: 'green' },
  REQUESTED: { label: '예약대기', color: 'yellow' },
  CONFIRMED: { label: '예약확정', color: 'blue' },
  REJECTED: { label: '거절됨', color: 'red' },
  COMPLETED: { label: '이용완료', color: 'green' },
  NO_SHOW: { label: '노쇼', color: 'red' },
};

export default function StatusBadge({ value, label }) {
  const preset = PRESETS[value] || { label: label || value, color: 'gray' };
  return <span className={`badge badge-${preset.color}`}>{label || preset.label}</span>;
}
